import get from 'lodash/get'
import { State } from './reducer'

export const selectDeferredActions = (state: State) => get(state, 'deferredActions', [])
